import { Dispatch, SetStateAction, useState } from 'react';

export let accountName: string;
export let setAccountName: Dispatch<SetStateAction<string>>;

export enum LoginTypeEnum {
  LOGOUT = 'logout',
  NO_SESSION = 'noSession',
  SESSION_EXPIRED = 'sessionExpired',
}

export let loginMsg: string;

export const useLogin = (initAccountName: string, loginType: LoginTypeEnum | undefined) => {
  [accountName, setAccountName] = useState(initAccountName);
  loginMsg = useState(getLoginMsg(loginType))[0];
};

/**
 * @private
 */
const getLoginMsg = (loginType: LoginTypeEnum | undefined) => {
  switch (loginType) {
    case LoginTypeEnum.LOGOUT:
      return 'ログアウトしました。';
    case LoginTypeEnum.NO_SESSION:
      return 'セッションの期限が切れています。再度ログインしてください。';
    case LoginTypeEnum.SESSION_EXPIRED:
      return 'ログインが確認できませんでした。ログイン後ご利用ください。';
    default:
      return '';
  }
};
